import React from "react";

const languageCodes = (props) => {
  return (
    <div className="mt-3">
      <h4 className="heading4 fw-sb text-color2">First Language</h4>
      <div className="row mb-4">
        <div className="col-md-4">
          <ul className="mb-0 list-unstyled">
            <li>
              <div className="d-flex justify-content-between">
                <span>Afrikaans</span>
                <span>001</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Akan</span>
                <span>002</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Albanian</span>
                <span>003</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Amharic</span>
                <span>004</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Arabic</span>
                <span>005</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Armenian</span>
                <span>006</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Assamese</span>
                <span>007</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Aymara</span>
                <span>008</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Azeri</span>
                <span>009</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Baluchi</span>
                <span>010</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Bambara</span>
                <span>011</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Basque</span>
                <span>012</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Belarusian</span>
                <span>019</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Bemba</span>
                <span>013</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Bengali</span>
                <span>014</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Bihari</span>
                <span>015</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Bosnian</span>
                <span>901</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Breton</span>
                <span>016</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Bulgarian</span>
                <span>017</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Burmese</span>
                <span>018</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Catalan</span>
                <span>020</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Chinese</span>
                <span>021</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Creole</span>
                <span>022</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Croatian</span>
                <span>023</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Czech</span>
                <span>024</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Danish</span>
                <span>025</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Dari</span>
                <span>026</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Dutch</span>
                <span>027</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Dzongkha</span>
                <span>028</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Efik</span>
                <span>029</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>English</span>
                <span>030</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Estonian</span>
                <span>031</span>
              </div>
            </li>

            <li>
              <div className="d-flex justify-content-between">
                <span>Ewe</span>
                <span>032</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Faeroese</span>
                <span>033</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Farsi</span>
                <span>034</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Fijian</span>
                <span>035</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Filipino</span>
                <span>904</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Finnish</span>
                <span>036</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Flemish</span>
                <span>037</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>French</span>
                <span>038</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Fulani</span>
                <span>039</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Ga</span>
                <span>040</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Galician</span>
                <span>903</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Georgian</span>
                <span>041</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>German</span>
                <span>042</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Gilbertese</span>
                <span>043</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Greek</span>
                <span>044</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Gujarati</span>
                <span>045</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Haitian Creole</span>
                <span>046</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Hausa</span>
                <span>047</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Hebrew</span>
                <span>048</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Hindi</span>
                <span>049</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Hungarian</span>
                <span>050</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Ibo/lgbo</span>
                <span>051</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Icelandic</span>
                <span>052</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Igala</span>
                <span>053</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Indonesian</span>
                <span>054</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Irish</span>
                <span>137</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Italian</span>
                <span>055</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Japanese</span>
                <span>056</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Javanese</span>
                <span>057</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Kannada</span>
                <span>058</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Kashmiri</span>
                <span>059</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Kazakh</span>
                <span>060</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Khmer</span>
                <span>061</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Korean</span>
                <span>062</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Kurdish</span>
                <span>063</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Lao</span>
                <span>064</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Latvian</span>
                <span>065</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Lithuanian</span>
                <span>066</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Luba</span>
                <span>067</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Luo</span>
                <span>068</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Luxemburgish</span>
                <span>069</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Macedonian</span>
                <span>902</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Malagasy</span>
                <span>070</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Malay</span>
                <span>071</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Malayalam</span>
                <span>072</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Malinka</span>
                <span>073</span>
              </div>
            </li>
          </ul>
        </div>
        <div className="col-md-4">
          <ul className="mb-0 list-unstyled">
            <li>
              <div className="d-flex justify-content-between">
                <span>Maltese</span>
                <span>074</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Maori</span>
                <span>075</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Marathi</span>
                <span>076</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Marshallese</span>
                <span>077</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Masai</span>
                <span>078</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Mende</span>
                <span>079</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Mongolian</span>
                <span>080</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Nepali</span>
                <span>081</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Norwegian</span>
                <span>082</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Oriya</span>
                <span>083</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Palauan</span>
                <span>084</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Pashto</span>
                <span>085</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Polish</span>
                <span>086</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Ponapean</span>
                <span>087</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Portuguese</span>
                <span>088</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Punjabi</span>
                <span>089</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Pushtu</span>
                <span>090</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Quechua</span>
                <span>091</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Rajasthani</span>
                <span>092</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Riff</span>
                <span>093</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Romanian</span>
                <span>094</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Romansch</span>
                <span>095</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Russian</span>
                <span>096</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Samoan</span>
                <span>097</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Scottish Gaelic</span>
                <span>138</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Serbian</span>
                <span>098</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Setswana</span>
                <span>099</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Shona</span>
                <span>100</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Sindh</span>
                <span>101</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Singhalese</span>
                <span>102</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Slovak</span>
                <span>103</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Slovene</span>
                <span>104</span>
              </div>
            </li>

            <li>
              <div className="d-flex justify-content-between">
                <span>Somali</span>
                <span>105</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Spanish</span>
                <span>106</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Swahili</span>
                <span>107</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Swazi</span>
                <span>108</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Swedish</span>
                <span>109</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tagalog</span>
                <span>110</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tahitian</span>
                <span>111</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tamil</span>
                <span>112</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tatar</span>
                <span>113</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Telugu</span>
                <span>114</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tetum</span>
                <span>136</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Thai</span>
                <span>115</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tibetan</span>
                <span>116</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tigrinya</span>
                <span>117</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tongan</span>
                <span>118</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Trukese</span>
                <span>119</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tulu</span>
                <span>120</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Tupi/Guarani</span>
                <span>121</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Turkish</span>
                <span>122</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Uighur</span>
                <span>123</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Ukrainian</span>
                <span>124</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Ulithian</span>
                <span>125</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Urdu</span>
                <span>126</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Uzbek</span>
                <span>127</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Vietnamese</span>
                <span>128</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Welsh</span>
                <span>139</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Wolof</span>
                <span>129</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Xhosa</span>
                <span>130</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Yao</span>
                <span>131</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Yapese</span>
                <span>132</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Yiddish</span>
                <span>133</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Yoruba</span>
                <span>134</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Zulu</span>
                <span>135</span>
              </div>
            </li>
            <li>
              <div className="d-flex justify-content-between">
                <span>Other</span>
                <span>000</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default languageCodes;
